const t = {
  name: "Egypt",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24 18.6894L12 1.23486L0 18.6894V23H24V18.6894ZM2 21V19.3106L2.90791 17.99H8.17196L8 18.9071V21H2ZM10 21V19.093L10.2068 17.99H21.0921L22 19.3106V21H10ZM19.7171 15.99H10.5818L11.1443 12.99H17.6546L19.7171 15.99ZM16.2796 10.99H11.5193L12.5394 5.54967L16.2796 10.99ZM10.146 7.4619L9.48446 10.99H7.72041L10.146 7.4619ZM6.34541 12.99H9.10946L8.54696 15.99H4.28291L6.34541 12.99Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Egypt
};
